// extracted by mini-css-extract-plugin
module.exports = {"component":"logo_component__2t1Y1","logo":"logo_logo__SMbkL"};